import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  tag: IJsonResponse
}

const FIELDS = {
  id: 'id',
  name: 'name',
  name_ja: 'name_ja',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('tag', { scope: 'activerecord.models' }),
})

const AdminTagEdit: React.FC<IProps> = props => {
  const { data } = adminService.getDataFromJson(props.tag)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { updatedTag, flush } = await adminService.updateTag(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/tags'
  }, [])

  return (
    <AdminLayoutEdit
      model="tag"
      title={title}
      fields={FIELDS}
      indexLink="/admin/tags"
      formItems={
        <>
          <InputText
            readonly={true}
            name="id"
            defaultValue={data.id}
            label={I18n.t('generic.id')}
          />
          <InputText
            required={true}
            name="name"
            defaultValue={data.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={false}
            name="name_ja"
            defaultValue={data.name_ja}
            label={I18n.t('generic.name_ja')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue={data.position}
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminTagEdit
